import ForwardModal from "@/Components/ForwardModal";
import ShareModal from "@/Components/ShareModal";
import { createContext, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";

export const GlobalContext = createContext();

function getCookies() {
    return document.cookie.split("; ").reduce((acc, cookie) => {
        const [key, value] = cookie.split("=");
        acc[key] = decodeURIComponent(value);
        return acc;
    }, {});
}

function getCookie(name) {
    const cookies = getCookies();
    return cookies[name] ? JSON.parse(cookies[name]) : [];
}

function setCookie(name, value, path = "/") {
    document.cookie = `${name}=${JSON.stringify(value)}; path=${path}`;
}

export default function GlobalProvider({ children, page }) {
    const { csrf_token } = page.props;
    const [state, setState] = useState({
        selected: -1,
        isOpenForwardModal: false,
        isOpenShareModal: false,
        propertySelected: null,
        favorites: [],
    });

    useEffect(() => {
        const cookieValue = getCookie("turnkeyFavoriteList");

        let favorites = [];
        if (cookieValue) {
            try {
                favorites = JSON.parse(cookieValue);
            } catch (error) {
                console.error("Error parsing the favorites cookie:", error);
            }
        }

        const favoriteParams = favorites.join(",");
        fetch(`/api/favorites?properties=${favoriteParams}`)
            .then((response) => response.json())
            .then((data) => {
                const references = data.references;

                setCookie(
                    "turnkeyFavoriteList",
                    JSON.stringify(references),
                    "/"
                );

                setState((old) => ({ ...old, favorites: references }));
            })
            .catch((error) => {
                console.error("Error fetching favorites:", error);
            });
    }, []);

    useEffect(() => {
        if (state.isOpenForwardModal || state.isOpenShareModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [state.isOpenForwardModal, state.isOpenShareModal]);

    function toggleFavorite(reference = null) {
        if (!reference) return;

        const cookieValue = getCookie("turnkeyFavoriteList");

        let favorites = [];
        if (cookieValue) {
            try {
                favorites = JSON.parse(cookieValue);
            } catch (error) {
                console.error("Error parsing the favorites cookie:", error);
            }
        }

        const index = favorites.indexOf(reference);

        if (index > -1) {
            favorites.splice(index, 1);
        } else {
            favorites.push(reference);
        }

        setCookie("turnkeyFavoriteList", JSON.stringify(favorites), "/");
        setState((old) => ({ ...old, favorites }));
    }

    function openForwardModal() {
        setState((old) => ({ ...old, isOpenForwardModal: true }));
    }

    function closeForwardModal() {
        setState((old) => ({ ...old, isOpenForwardModal: false }));
    }

    function openShareModal(property) {
        setState((old) => ({
            ...old,
            isOpenShareModal: true,
            propertySelected: property,
        }));
    }

    function closeShareModal() {
        setState((old) => ({ ...old, isOpenShareModal: false }));
    }

    return (
        <GlobalContext.Provider
            value={{
                ...state,
                csrf_token,
                toggleFavorite,
                openForwardModal,
                closeForwardModal,
                openShareModal,
                closeShareModal,
            }}
        >
            <ForwardModal />
            <ShareModal />
            {children}
            <ToastContainer />
        </GlobalContext.Provider>
    );
}
